<script setup>
import { categoryNavigation } from '../config/navigation.js';
</script>
<template>
<section class="hero" id="home">
    <div class="hero-noise"></div>
    <div class="page-wrap hero-layout">
      <div class="hero-copy reveal">
        <p class="hero-kicker">منصة موثوقة لاكتشاف موارد السنة</p>
        <h1>اكتشف منظومة<br><span>خدمة السنة النبوية</span></h1>
        <p>دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بها من مبادرات ومنتجات وأفكار.</p>
        <div class="hero-actions"><RouterLink class="cta cta-gold magnetic" :to="{name:'home',hash:'#categories'}"><i class="bi bi-plus"></i> استكشف الدليل</RouterLink><RouterLink class="cta cta-outline" :to="{name:'about'}">تعرّف أكثر</RouterLink></div>
      </div>
      <div class="product-scene reveal" aria-label="معاينة واجهة الدليل">
        <div class="browser-card">
          <div class="browser-dots"><i></i><i></i><i></i></div>
          <div class="mini-search"><span>ابحث في الدليل</span><i class="bi bi-search"></i></div>
          <strong>نتائج البحث</strong>
          <div class="result-row"><img src="/assets/img/512x512bb4.jpg" alt=""><span><b>موسوعة الحديث النبوي</b><small>موقع موثوق</small></span></div>
          <div class="result-row"><img src="/assets/img/512x512bb-112.jpg" alt=""><span><b>الموسوعة الحديثية</b><small>تطبيق هاتفي</small></span></div>
          <div class="result-row"><img src="/assets/img/jamaa-alhdyth-alnboy-18.png" alt=""><span><b>جامع الحديث</b><small>خدمة بحثية</small></span></div>
        </div>
        <div class="stats-card"><div><b>85</b><span>موقعًا موثوقًا</span></div><div><b>109</b><span>تطبيقات</span></div><div><b>27</b><span>مركزًا تعليميًا</span></div></div>
      </div>
    </div>
    <form class="hero-search reveal" id="heroSearch" role="search">
      <div class="hero-search-shell">
        <div class="search-input-zone">
          <i class="bi bi-search" aria-hidden="true"></i>
          <label class="visually-hidden" for="heroQuery">كلمة البحث</label>
          <input id="heroQuery" type="search" placeholder="ابحث عن موقع، تطبيق، بحث، مركز أو مورد...">
        </div>
        <span class="search-separator separator-one" aria-hidden="true"></span>
        <div class="search-select-zone">
          <label class="visually-hidden" for="heroCategory">جميع الأقسام</label>
          <select id="heroCategory"><option value="">جميع الأقسام</option><option v-for="item in categoryNavigation" :key="item.id">{{ item.label }}</option></select>
          <i class="bi bi-chevron-down" aria-hidden="true"></i>
        </div>
        <span class="search-separator separator-two" aria-hidden="true"></span>
        <button type="submit">بحث</button>
      </div>
      <div class="hero-search-chips" aria-label="تصفية سريعة">
        <button type="button" data-quick-category="مواقع خدمة السنة">مواقع خدمة السنة</button>
        <button type="button" data-quick-category="التطبيقات الهاتفية">التطبيقات</button>
        <button type="button" data-quick-category="بحوث في السنة">البحوث</button>
        <button type="button" data-quick-category="مراكز تعليم السنة">مراكز تعليم السنة</button>
        <button type="button" data-quick-category="قنوات وإذاعات">قنوات وإذاعات</button>
      </div>
    </form>
  </section>
</template>

